exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".yxtbiz-ai-robot-empty-data[data-v-6ebc6ac5]{padding-left:12px;color:#262626}\n", ""]);

